import { create } from 'zustand'


interface useRedRibbonEntity {
    isOpen: boolean;
    isUpdate: boolean;
    productionPlannedStatus: { type: string, status: string[] | [] },
    count: boolean;
    setProductionPlannedStatus: (type: string, status: string[]) => void;
    setClose: () => void;
    setOpen: () => void;
    setCount: (count: boolean) => void;
    setToggleUpdate: () => void;
    resetRedRibbon: () => void;
}

export const useRedRibbon = create<useRedRibbonEntity>((set) => ({
    isOpen: false,
    count: true,
    isUpdate: false,
    productionPlannedStatus: { type: "", status: [] },
    setCount: (count) => set((state => ({ count }))),
    setProductionPlannedStatus: (type, status) => set((state => ({ productionPlannedStatus: { type, status } }))),
    setToggleUpdate: () => set((state => ({ isUpdate: !state.isUpdate }))),
    setClose: () => set((state) => ({ isOpen: false })),
    setOpen: () => set((state) => ({ isOpen: true })),
    resetRedRibbon: () => set(() => ({
        isOpen: false,
        count: false,
        isUpdate: false,
        productionPlannedStatus: { type: "", status: [] },
    }))
}))
